export default __webpack_public_path__ + "static/media/MC-1.05448ed4.gif";